const useMockArray = (type?: string, limit?: number) => {
  const countries = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua & Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia & Herzegovina',
    'Botswana',
    'Brazil',
    'British Virgin Islands',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Cape Verde',
    'Cayman Islands',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Cote D Ivoire',
    'Croatia',
    'Cruise Ship',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Polynesia',
    'French West Indies',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kuwait',
    'Kyrgyz Republic',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Pakistan',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Pierre & Miquelon',
    'Samoa',
    'San Marino',
    'Satellite',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'St Kitts & Nevis',
    'St Lucia',
    'St Vincent',
    'St. Lucia',
    'Sudan',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    "Timor L'Este",
    'Togo',
    'Tonga',
    'Trinidad & Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks & Caicos',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Venezuela',
    'Vietnam',
    'Virgin Islands (US)',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ];
  const animals = [
    'meerkat',
    'aardvark',
    'alligator',
    'alpaca',
    'anteater',
    'armadillo',
    'baboon',
    'badger',
    'basilisk',
    'bat',
    'bear',
    'beaver',
    'bighorn',
    'bison',
    'buffalo',
    'bull',
    'capybara',
    'cat',
    'chameleon',
    'cheetah',
    'chimpanzee',
    'chinchilla',
    'chipmunk',
    'coyote',
    'crocodile',
    'deer',
    'dingo',
    'dung beetle',
    'dog',
    'donkey',
    'duckbill platypus',
    'elephant',
    'elk',
    'fish',
    'fox',
    'frog',
    'gazelle',
    'gemsbok',
    'gila monster',
    'giraffe',
    'gorilla',
    'grizzly bear',
    'hare',
    'hartebeest',
    'hedgehog',
    'jackal',
    'jaguar',
    'jerboa',
    'kangaroo',
    'kitten',
    'koala',
    'lamb',
    'lemur',
    'leopard',
    'lion',
    'lizard',
    'llama',
    'lovebird',
    'lynx',
    'mandrill',
    'mare',
    'marmoset',
    'marten',
    'mink',
    'mole',
    'mongoose',
    'monkey',
    'moose',
    'mountain goat',
    'mouse',
    'mynah bird',
    'newt',
    'ocelot',
    'okapi',
    'opossum',
    'orangutan',
    'oryx',
    'otter',
    'ox',
    'panda',
    'panther',
    'parakeet',
    'parrot',
    'peccary',
    'pig',
    'octopus',
    'thorny devil',
    'starfish',
    'blue crab',
    'snowy owl',
    'chicken',
    'rooster',
    'bumble bee',
    'eagle owl',
    'polar bear',
    'pony',
    'pronghorn',
    'puma',
    'puppy',
    'quagga',
    'rabbit',
    'seal',
    'sheep',
    'shrew',
    'silver fox',
    'skunk',
    'sloth',
    'snake',
    'springbok',
    'squirrel',
    'stallion',
    'steer',
    'tapir',
    'warthog',
    'whale',
    'wildcat',
    'bald eagle',
    'wolf',
    'wolverine',
    'wombat',
    'woodchuck',
    'yak',
    'zebra',
  ];

  const array = type === 'animals' ? animals : countries;
  if (limit) {
    return array.sort(() => Math.random() - 0.5).slice(0, limit);
  }
  return array;
};

export default useMockArray;
